import { render, staticRenderFns } from "./updateKycGroup.vue?vue&type=template&id=1d10475e"
import script from "./updateKycGroup.vue?vue&type=script&lang=js"
export * from "./updateKycGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports